export default "__VITE_ASSET__4639c953__"